<script setup>
import { computed, defineAsyncComponent, ref, watch } from 'vue'
//Components
import { ClipboardIcon, PlaneFacingUpIcon } from 'Common/components/elements/icons/Icons'
import DroneSpinner from 'Common/components/elements/feedback/DroneSpinner.vue'
import ServerStatusViewHandler from 'Common/components/templates/ServerStatusViewHandler.vue'
import TabPanel from 'Common/components/elements/surfaces/TabPanel.vue'
//Modules
import AirFrameList from 'Modules/pages/home/AirFrameList.vue'
import RecentInspectionsList from 'Modules/pages/home/RecentInspectionsList.vue'
//API
import { useGetInspectionInstancesFiltered } from 'API/queries/iris/inspection-instance'
//Store
import { useFilterStore } from 'Store/filterStore'
import { storeToRefs } from 'pinia'

const props = defineProps({ layout: { type: String, default: 'PageLayout' } })
const filterStore = useFilterStore()
const { queryParamObj, areFiltersReady } = storeToRefs(filterStore)

const headerURL = new URL('../assets/plane-photos/737_lineup.png', import.meta.url)
const activeName = ref('airframeTab')
const layout = computed(() => defineAsyncComponent(() => import(`Modules/pages/home/${props.layout}.vue`)))
const { data: inspectionData, status } = useGetInspectionInstancesFiltered({
  variables: { filterQueryParams: queryParamObj },
  enabled: areFiltersReady,
  refetchOnWindowFocus: false,
})

const InspectionInstancesGroupedByAirFrame = computed(() => {
  return Array.isArray(inspectionData.value)
    ? inspectionData.value?.reduce((r, a) => {
        r[a.aircraftFrame] = r[a.aircraftFrame] || []
        const containsAircraft = r[a.aircraftFrame].find((entry) => entry.aircraftUuid === a.aircraftUuid) !== undefined
        if (!containsAircraft) r[a.aircraftFrame].push(a)
        return r
      }, Object.create(null))
    : []
})
</script>

<template>
  <component :is="layout">
    <template #header-image>
      <img :src="headerURL" alt="Boeing 737 Planes Lined Up" class="object-cover h-full w-full" />
    </template>
    <template #list-tabs>
      <el-tabs v-model="activeName" class="aircraft-list-tabs w-min mx-auto px-5 py-5">
        <el-tab-pane name="recentTab">
          <template #label>
            <span><ClipboardIcon class="mr-2" />RECENT</span>
          </template>
        </el-tab-pane>
        <el-tab-pane label="AIRFRAME" name="airframeTab">
          <template #label>
            <span><PlaneFacingUpIcon class="mr-2" />AIRFRAME</span>
          </template>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template #aircraft-lists>
      <TabPanel :value="activeName" index="recentTab">
        <ServerStatusViewHandler :statuses="[status]">
          <template #loading>
            <div class="h-full w-full pb-10 flex items-center justify-center">
              <DroneSpinner />
            </div>
          </template>
          <template #error> error... </template>
          <template #success>
            <div class="px-5 h-full">
              <RecentInspectionsList :data="Array.isArray(inspectionData) ? inspectionData : []" />
            </div>
          </template>
        </ServerStatusViewHandler>
      </TabPanel>
      <TabPanel :value="activeName" index="airframeTab">
        <ServerStatusViewHandler :statuses="[status]">
          <template #loading>
            <div class="h-full w-full pb-10 flex items-center justify-center">
              <DroneSpinner />
            </div>
          </template>
          <template #error> error... </template>
          <template #success>
            <div class="px-5 h-full">
              <AirFrameList :data="InspectionInstancesGroupedByAirFrame" />
            </div>
          </template>
        </ServerStatusViewHandler>
      </TabPanel>
    </template>
  </component>
</template>
